export const appCdnURL = ""

export const appHead = {"meta":[{"charset":"utf-8"},{"http-equiv":"x-ua-compatiable","content":"IE=edge"},{"name":"viewport","content":"width=device-width,initial-scale=1.0,maximum-scale=5.0"},{"hid":"description","name":"description","content":"Zenapptic provides an AI-powered, real-time platform that drives visual experiences at work and at play."},{"hid":"og:title","name":"og:title","content":"Zenapptic Ai"},{"hid":"og:description","name":"og:description","content":"Zenapptic provides an AI-powered, real-time platform that drives visual experiences at work and at play."},{"hid":"og:url","name":"og:url","content":"https://www.zenapptic.ai"},{"hid":"og:site_name","name":"og:site_name","content":"Zenapptic Ai"},{"hid":"og:image","name":"og:image","content":"https://static.zenweb-dev.zenapptic.dev/zen-social-card.jpeg"},{"hid":"twitter:card","name":"twitter:card","content":"https://static.zenweb-dev.zenapptic.dev/zen-social-card.jpeg"},{"hid":"twitter:image:alt","name":"twitter:image:alt","content":"Zenapptic Ai"}],"link":[{"rel":"icon","type":"image/x-icon","href":"https://static.zenweb-dev.zenapptic.dev/favicon.png"}],"style":[],"script":[],"noscript":[],"title":"Zenapptic AI  - Visual experience platform","htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "nuxt:preloadError"